import axios from '../util/request'
// import qs from 'qs'
const md5 = require('js-md5')
const stamp = Date.now()
// 获取okey
export const getOkey = () => {
  return axios.get('/api/xiaosen/user/info/getOKey', {
    params: {
      stamp
    }
  })
}

// 上传图片
export const upload = (file) => {
  const okey = localStorage.getItem('okey') ? window.atob(localStorage.getItem('okey')) : ''
  const sign = md5(`${stamp}${okey}`)
  const data = new FormData()
  data.append('upload', file)
  data.append('stamp', stamp)
  data.append('sign', sign)
  return axios.post('/api/xiaosen/common/uploadFile', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 门店列表
export const shopList = () => {
  return axios.get('/res/giftshoplist.json')
}

// 产品列表
export const productList = () => {
  return axios.get('/res/giftprodlist.json')
}